export default __webpack_public_path__ + "static/media/logos_camara.b4abc645.png";